var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout layout--error"},[_c('div',{staticClass:"layout__container"},[_c('div',{staticClass:"layout__header"}),_c('div',{staticClass:"layout__body"},[_c('nuxt')],1),_c('div',{staticClass:"layout__footer"})])])}
var staticRenderFns = []

export { render, staticRenderFns }